<div class="streamdust-player-container"
     [class.streamdust-player-container-embedded]="playerDisplayMode === PLAYER_DISPLAY_MODE.EMBEDDED" #videoWrapper>
    <ano-loader [isOpen]="loading"></ano-loader>
    <ng-template #chatTmpl></ng-template>
</div>
